function randomInt(min, max) {
    return min + Math.floor((max - min) * Math.random());
}

function randomFloat(min, max) {
    return min + (max - min) * Math.random();
}

function padDigits(number, digits = 2, padSign = 0) {
    const sign = number < 0 ? '-' : '';
    const padCount = number < 0 ? digits + 1 : digits;
    return `${sign}${Array(Math.max(padCount - String(number).length + 1, 0)).join(padSign) + Math.abs(number)}`;
}

function parseNumber(value) {
    let valueCopy = value;
    if (typeof valueCopy !== 'string') {
        return parseFloat(valueCopy);
    }

    const isDot = valueCopy.indexOf('.');
    const isComa = valueCopy.indexOf(',');

    if (isDot !== -1 && isComa !== -1) {
        if (isComa > isDot) {
            valueCopy = valueCopy.replace('.', '').replace(',', '.');
        } else {
            valueCopy = valueCopy.replace(',', '');
        }
    } else if (isComa !== -1) {
        valueCopy = valueCopy.replace(',', '.');
    }

    return parseFloat(valueCopy);
}

/**
 *
 * @param {number} numberA
 * @param {number} numberB
 * @returns {number}
 */
function summaryTwoFloat(numberA, numberB) {
    return parseFloat((numberA + numberB).toFixed(10));
}

export {
    randomInt,
    randomFloat,
    padDigits,
    parseNumber,
    summaryTwoFloat,
};
